const authReducer = (
  state = {
    loading: false,
    data: {
      accessToken: null,
      uid: null,
      phoneNumber: null,
      displayName: null,
      claims: null
    },
    credentials: {
      verificationId: null,
      authCredential: null
    },
    theme: {
      primaryColor: "#F3F3F3",
      secondaryColor: "#4D8ECB",
      secondaryColor1: "#D8E3ED",
      tertiaryColor: "#0E0E0E",
      tertiaryColor1: "#FFFFFF",
      tertiaryColor2: "#FFFFFF",
      tertiaryColor3: "#CFCFCF",
      tertiaryColor4: "#AFAFAF",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#353535",
      tertiaryColor7: "#262626",
      tertiaryColor8: "#E1E1E1",
      tertiaryColor9: "#00000014"
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_AUTH_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_AUTH_INFO":
      return {
        ...state,
        data: action.payload
      };

    case "SET_AUTH_VERIFICATION_ID":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          verificationId: action.payload.verificationId
        }
      };

    case "SET_ACCESS_TOKEN":
      return {
        ...state,
        data: {
          ...state.data,
          accessToken: action.payload.accessToken
        }
      };

    case "SET_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authCredential: action.payload.authCredential
        }
      };

    case "CLEAR_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          verificationId: null,
          authCredential: null
        }
      };

    case "PUT_THEME":
      return {
        ...state,
        theme: action.payload.theme
      };

    case "RESET":
      return {
        loading: false,
        data: {
          accessToken: null,
          uid: null,
          phoneNumber: null,
          displayName: null
        },
        credentials: {
          verificationId: null,
          authCredential: null
        },
        theme: {
          primaryColor: "#F3F3F3",
          secondaryColor: "#4D8ECB",
          secondaryColor1: "#D8E3ED",
          tertiaryColor: "#0E0E0E",
          tertiaryColor1: "#FFFFFF",
          tertiaryColor2: "#FFFFFF",
          tertiaryColor3: "#CFCFCF",
          tertiaryColor4: "#AFAFAF",
          tertiaryColor5: "#6E6E6E",
          tertiaryColor6: "#353535",
          tertiaryColor7: "#262626",
          tertiaryColor8: "#E1E1E1",
          tertiaryColor9: "#00000014"
        }
      };

    default:
      return state;
  }
};
export default authReducer;
